// extracted by mini-css-extract-plugin
module.exports = {"root":"CameraOption_root__E1Zxn"};